export enum ActionTypes {
    USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE',
    USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST',
    USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS',
    USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS',

    PROFILE_PROJECTS_LOADED = 'PROFILE_PROJECTS_LOADED',
    PROFILE_CONSENTED_PROJECTS_LOADED = 'PROFILE_CONSENTED_PROJECTS_LOADED',

    DEMO_DATA_PENDING = 'DEMO_DATA_PENDING',
    DEMO_DATA_READY = 'DEMO_DATA_READY',
    DEMO_SHOW_RESULT = 'DEMO_SHOW_RESULT',
}




// WEBPACK FOOTER //
// ./src/types/action-types.ts